import React, { FC } from 'react';
import {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  CoffeeOutlined, SmileFilled, SmileOutlined, SmileTwoTone,
} from '@ant-design/icons';
import { Col, Row } from 'antd';

interface Props {
  repetitions: number;
  checks: unknown[];
  icon?: string;
  iconSize?: string;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Checks: FC<Props> = (props: Props) => {
  const {
    repetitions, checks, icon, iconSize,
  } = props;
  return (
    <Row style={{
      margin: '1.5vh auto 1.5vh auto',
      padding: '4%',
      border: '2px dashed #07668c',
    }}
    >
      <Col style={{ width: '100%' }}>
        {Array.apply('', Array(repetitions)).map((v, index) => {
          const Icon = icon === 'COFFEE' ? CoffeeOutlined : SmileOutlined;
          const color = checks.length > index ? '#f2a413' : '#05374255';

          return (
            <Icon
            // eslint-disable-next-line react/no-array-index-key
              key={index}
              twoToneColor={color}
              style={{
                fontSize: iconSize,
                margin: '10px',
                color,
              }}
            />
          );
        })}
      </Col>
    </Row>
  );
};

Checks.defaultProps = { iconSize: '40px', icon: 'COFFEE' };

export default Checks;
